<template>
  <div class="rowSelect">
    <template v-for="(item, i) in group">
      <v-btn :key="i" text color="primary" @click="toggleBtn(i)">
        <div class="rowSelect_text">
          {{ textValue[i] }}
        </div>
        <span
          class="icon icon-chevron-down"
          :class="{ 'rowSelect_chevron-open': open && selectedGroup == i }"
        />
      </v-btn>
    </template>
    <div v-if="open" class="rowSelect_list">
      <template v-for="(item, i) in group[selectedGroup].list">
        <v-btn
          :key="i"
          depressed
          x-small
          text
          outlined
          class="rowSelect_list-btn"
          :class="{
            'rowSelect_list-btn-selected': selectedItem[selectedGroup] == i,
          }"
          @click="onSelect(i)"
        >
          {{ item.text }}
        </v-btn>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RowSelect',
  components: {},
  props: {
    group: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      open: false,
      selectedItem: {},
      textValue: {},
      selectedGroup: 0,
    };
  },
  watch: {},
  created() {
    this.group.forEach((select, i) => {
      this.$set(this.textValue, i, this.group[i].label);
      if (this.group[i].defaultItem !== undefined) {
        this.$set(this.selectedItem, i, this.group[i].defaultItem);
        this.$set(
          this.textValue,
          i,
          this.group[i].textOnSelect
            ? this.group[i].textOnSelect(
                this.group[i].list[this.group[i].defaultItem]
              )
            : this.group[i].label
        );
      }
    });
  },
  methods: {
    toggleBtn(groupIndex) {
      if (this.open && this.selectedGroup === groupIndex) {
        this.open = false;
      } else {
        this.open = true;
      }
      this.selectedGroup = groupIndex;
    },
    onSelect(index) {
      this.$set(this.selectedItem, this.selectedGroup, index);
      this.$emit('select', {
        value: this.group[this.selectedGroup].list[index],
        index,
        group: this.selectedGroup,
      });
      this.$set(
        this.textValue,
        this.selectedGroup,
        this.group[this.selectedGroup].textOnSelect
          ? this.group[this.selectedGroup].textOnSelect(
              this.group[this.selectedGroup].list[index]
            )
          : this.group[this.selectedGroup].list[index].text
      );
    },
  },
};
</script>

<style lang="scss">
.rowSelect {
  width: 100%;
  &_chevron {
    &-open {
      transform: rotate(180deg);
    }
  }
  &_list {
    margin-top: 5px;
    border-top: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
    padding: 10px 0;

    &-btn {
      margin: 0;
      padding: 0;
      color: #989898 !important;
      margin-right: 5px;
      font-size: 12px !important;
      line-height: 1.08 !important;
      border: solid 1px #989898;
      border-color: #989898;
      font-family: 'Noto Sans JP', sans-serif;
      &-selected {
        color: #0075c2 !important;
        background-color: #dbe2f3;
        border: none;
      }
    }
  }
}
</style>
